export class RepairAssignment {
    channelTypeCode: string;
    estimatingId: string;
    participantType?: string;
    vehicleNumber: string;
    closedClaim?: string;
}
